import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  inject
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { debounceTime } from "rxjs/operators";

@Component({
    selector: "app-date-range-picker",
    templateUrl: "./date-range-picker.component.html",
    styleUrls: ["./date-range-picker.component.scss"],
    standalone: false
})
export class DateRangePickerComponent {
  private readonly destroyRef = inject(DestroyRef);
  @Input() set initialDateRange(dateRange: Date[]) {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      this.nonUIChange = true;
      this.range.controls["start"].setValue(dateRange[0]);
      this.range.controls["end"].setValue(dateRange[1]);
    }
  }
  @Output() dateRangeChanged = new EventEmitter<Date[]>();

  constructor() {
    this.range.valueChanges.pipe(debounceTime(200)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => {
      if (this.range.valid) {
        const dates = [];
        dates.push(this.range.controls["start"].value);
        dates.push(this.range.controls["end"].value);
        if (!this.nonUIChange) {
          this.dateRangeChanged.emit(dates);
        }
        this.nonUIChange = false;
      }
    });
  }

  range = new FormGroup({
    start: new FormControl(null, Validators.required.bind(Validators)),
    end: new FormControl(null, Validators.required.bind(Validators)),
  });

  private nonUIChange: boolean;
}
